/* ============
 * Product Module State
 * ============
 */

export default {
  all: [],
  basic: [],
  items: [],
  pagination: {
    currentPage: 1,
    lastPage: 0,
    limit: 5,
    totalCount: 0,
  },
  transactions: [],
  transactionsV2: [],
  paginateTransactionsV2: {
    items: [],
    pagination: {
      currentPage: 1,
      lastPage: 0,
      limit: 5,
      totalCount: 0,
    },
  },
  productPrices: [],
  query: {
    page: 1,
    limit: 50,
    search: '',
    grouping: '',
    isSet: false,
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/product/state.js